import {IAction} from "../model/IAction";

import * as FetchActions from "../actions/FetchDataItems";

import { ISimpleApiSpecificationData } from "../../apiManagement/model/model";

export function apiSpecs(state: ISimpleApiSpecificationData[] = [], action: IAction): ISimpleApiSpecificationData[] {
     switch (action.type) {
        case FetchActions.RECEIVE_API_SPECS: {
            const receiveAction = action as FetchActions.IReceiveApiSpecsAction;
            return receiveAction.apiSpecData;
        }
        default:
            return state;
    }
}
